import restApiConnection from '@/services/api/providers/Connection'
import driversResponse from '@/types/responses/driversResponse'
import RestApiBase from '@/services/models/RestApiBase'
import UserSession from '@/services/models/UserSession'
import { CACHE_TTL_DEFAULT } from '@/config'

export default class Driver extends RestApiBase {
  public static async all({
    operationOfficeIds = [],
  }: {
    operationOfficeIds?: number[]
  } = {}): Promise<driversResponse> {
    return this.sync('GetDrivers', () => {
      return this.selectAll({ operationOfficeIds })
    })
  }

  public static selectAll = async ({
    retryCount = 0,
    operationOfficeIds = [],
  }: {
    retryCount?: number
    operationOfficeIds?: number[]
  } = {}): Promise<driversResponse> => {
    if (retryCount > 3) {
      throw new Error('Maximum retry attempts reached')
    }

    const config = {
      cache: {
        ttl: CACHE_TTL_DEFAULT,
      },
      params: {
        user_session_id: UserSession.getStoredUserId(),
        operation_office_ids: operationOfficeIds?.join(','),
      },
    }

    return await restApiConnection
      .get('/drivers', config)
      .catch(async (error) => {
        console.error('API Call Failed on driver. Error:', error)
        throw error
      })
  }
}
